module.exports = __webpack_public_path__ + "media/src/images/stripe-logo-ecf3d13d95b3e4f36adb61c13d830735.png";